<template>
  <div v-if="displayTimerBar" :style="{ backgroundColor: backgroundColor, color: textColor }"
       :class="`timer rounded ${isDailyDeal ? 'p-3 dailyDealBanner' : 'homePageBanner'}`">
    <div
      :class="`container d-flex flex-column flex-md-row ${isDailyDeal ? 'justify-content-between' : 'justify-content-center gap-12'}`">
      <!-- Content -->
      <div v-if="enableContent" :class="`mt-md-0 align-self-center ${isDailyDeal ? 'mb-2' : ''}`">
        <slot name="content"></slot>
      </div>

      <div :class="['d-flex', enableContent ? 'justify-content-end' : 'justify-content-center w-100 text-center']">
        <div v-if="isDailyDeal" class="d-flex flex-column text-center justify-content-center align-items-center justify-content-center mr-4">
          <div class="daily-deal-text">DAILY DEAL</div>
        </div>
        <!-- Counters -->
        <div class="d-flex">

          <div v-if="!isDailyDeal" class="d-flex flex-column text-center justify-content-center px-3 timer-border-right">
            <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Days</div>
            <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ days }}</div>
          </div>
          <div class="d-flex flex-column text-center justify-content-center px-3 timer-border-right">
            <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Hours</div>
            <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ hours }}</div>
          </div>
          <div class="d-flex flex-column text-center justify-content-center px-3 timer-border-right">
            <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Minutes</div>
            <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ minutes }}</div>
          </div>
          <div class="d-flex flex-column text-center justify-content-center px-3 ml-2">
            <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Seconds</div>
            <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ seconds }}</div>
          </div>
        </div>

        <!-- Close icon -->
        <div v-if="enableClose" class="d-flex">
          <div class="icon-wrap d-flex text-center px-3 align-items-center">
            <i class="las la-times la-m2x" style="cursor: pointer" @click="close"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isDailyDeal: false,
    dailyDealDate: { required: true },
    backgroundColor: { required: true },
    textColor: { required: true },
    enableClose: { type: Boolean, required: false, default: false },
    enableContent: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      displayTimerBar: true,
      startDate: new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
      ),
      endDate: this.getEndDate(),
      currentTime: null,
      isRunning: false,
      increaseTimer: 0
    }
  },
  computed: {
    days() {
      if ((this.currentTime && this.currentTime > this.endDate) || !this.dailyDealDate) {
        return "00"
      } else if (this.currentTime) {
        const remainingSeconds = Math.floor((this.endDate - this.currentTime) / 1000)
        const days = Math.floor(remainingSeconds / 86400) // 86400 seconds in a day
        return `${days.toString().padStart(2, "0")}`
      } else {
        return "00"
      }
    },
    hours() {
      this.increaseTimer
      if ((this.currentTime && this.currentTime > this.endDate) || !this.dailyDealDate) {
        return "00"
      } else if (this.currentTime) {
        const remainingSeconds = Math.floor((this.endDate - this.currentTime) / 1000)
        const hours = Math.floor((remainingSeconds % 86400) / 3600)
        return `${hours.toString().padStart(2, "0")}`
      } else {
        return "00"
      }
    },
    minutes() {
      this.increaseTimer
      if ((this.currentTime && this.currentTime > this.endDate) || !this.dailyDealDate) {
        return "00"
      } else if (this.currentTime) {
        const remainingSeconds = Math.floor((this.endDate - this.currentTime) / 1000)
        const minutes = Math.floor((remainingSeconds % 3600) / 60)
        return `${minutes.toString().padStart(2, "0")}`
      } else {
        return "00"
      }
    },
    seconds() {
      this.increaseTimer
      if ((this.currentTime && this.currentTime > this.endDate)) {
        return "00"
      } else if (this.currentTime) {
        const remainingSeconds = Math.floor((this.endDate - this.currentTime) / 1000)
        const seconds = remainingSeconds % 60
        return `${seconds.toString().padStart(2, "0")}`
      } else {
        return "00"
      }
    }
  },
  watch: {
    isRunning(newValue) {
      if (newValue) {
        this.currentTime = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
        )
      }
    },
    dailyDealDate() {
    }
  },
  methods: {
    startCountdown() {
      this.isRunning = true
      this.updateCountdown()
    },
    stopCountdown() {
      this.isRunning = false
    },
    updateCountdown() {
      if (this.isRunning) {
        this.currentTime = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
        )
        this.increaseTimer++
        if (this.currentTime > this.endDate) {
          this.isRunning = false
          return
        }
        requestAnimationFrame(this.updateCountdown)
      }
    },
    getEndDate() {
      let endDate = new Date(this.dailyDealDate ? this.dailyDealDate : new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
      ))
      endDate = endDate.setDate(endDate.getDate() + 1)
      return endDate
    },
    close() {
      this.displayTimerBar = false
    }
  },
  mounted() {
    this.startCountdown()
  }
}
</script>

<style scoped lang="scss">
.daily-deal-text {
  color: #fff;
  margin: 0px !important;
  font-size: 2rem !important;
}

.timer {
  color: white;
  background: orange;

  &.homePageBanner {
    min-height: 46px;
    padding-top: 2px;
    padding-bottom: 2px;
    display: flex;
    place-items: center;

  }
}

.timer-number {
  font-size: 1.2rem;
  font-weight: 600;
  &.homePageBanner {
    font-size: 14px;
  }
}

.timer-text {
  font-size: 1rem;
  text-transform: uppercase;
  &.homePageBanner {
    font-size: 10px;
  }
}

.timer-content {
  font-size: 1.2rem;
}

.timer-border-right {
  border-right: 2px solid white;
}

@media screen and (max-width: 500px) {
  .la-m2x {
    font-size: 1.7rem;
  }
}
</style>
